var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.292474 11.2875C-0.0956954 10.8966 -0.0949705 10.2649 0.294578 9.87539L3.46363 6.70634C3.85385 6.31611 3.8542 5.68354 3.4644 5.29289L0.293812 2.11538C-0.0950355 1.72569 -0.0946913 1.09466 0.294581 0.705384C0.684154 0.315811 1.31578 0.315811 1.70535 0.705384L6.29286 5.29289C6.68338 5.68342 6.68338 6.31658 6.29286 6.70711L1.70958 11.2904C1.31808 11.6819 0.682589 11.6804 0.292474 11.2875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.5d01b5282ffebcc5c81f24320840789c.svg";
export { ForwardRef as ReactComponent };